module.exports = __webpack_public_path__ + "static/pitchfork-wilco-d2aed58dcfae273c0d30acda531dce32.jpg";